import { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const IconDrag: FC<IProps> = ({ width = 12, height = 42 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="2.66667"
        cy="32.6663"
        r="2.66667"
        transform="rotate(-90 2.66667 32.6663)"
        fill="#BFBFBF"
      />
      <circle
        cx="2.66667"
        cy="25.9993"
        r="2.66667"
        transform="rotate(-90 2.66667 25.9993)"
        fill="#BFBFBF"
      />
      <circle
        cx="2.66667"
        cy="19.3333"
        r="2.66667"
        transform="rotate(-90 2.66667 19.3333)"
        fill="#BFBFBF"
      />
      <circle
        cx="2.66667"
        cy="12.6663"
        r="2.66667"
        transform="rotate(-90 2.66667 12.6663)"
        fill="#BFBFBF"
      />
      <circle
        cx="9.33268"
        cy="32.6663"
        r="2.66667"
        transform="rotate(-90 9.33268 32.6663)"
        fill="#BFBFBF"
      />
      <circle
        cx="9.33268"
        cy="25.9993"
        r="2.66667"
        transform="rotate(-90 9.33268 25.9993)"
        fill="#BFBFBF"
      />
      <circle
        cx="9.33268"
        cy="19.3333"
        r="2.66667"
        transform="rotate(-90 9.33268 19.3333)"
        fill="#BFBFBF"
      />
      <circle
        cx="9.33268"
        cy="12.6663"
        r="2.66667"
        transform="rotate(-90 9.33268 12.6663)"
        fill="#BFBFBF"
      />
    </svg>
  );
};

export default IconDrag;
